import React from 'react';
import "./PanelPlaceholder.css";
import LayoutUtils from "./layout/LayoutUtils.js";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
/**
 * Displays a placeholder for unregistered panel types.
 */
var PanelPlaceholder = /*#__PURE__*/React.forwardRef((props, ref) => {
  var component = LayoutUtils.getComponentNameFromPanel({
    props
  });
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    className: "panel-placeholder",
    children: /*#__PURE__*/_jsxs("div", {
      children: ["Component \"", component, "\" is not registered."]
    })
  });
});
PanelPlaceholder.displayName = 'PanelPlaceholder';
export default PanelPlaceholder;
//# sourceMappingURL=PanelPlaceholder.js.map